import React from "react";
import { Link, Stack } from "@fluentui/react";
import { AppTheme } from "./App";
import RehnLogo from "./RehnLogo";
import { HolidayOverride, HOLIDAYS, HOLIDAY_KEYS } from "./holidays";

interface FooterProps {
  theme: AppTheme;
  setTheme: (theme: AppTheme) => void;
  /** Tema valt via ?theme= i URL:en, eller null om det styrs av datumet. */
  holidayOverride: HolidayOverride | null;
}

/**
 * Bygger en länk som byter högtidstema men behåller namn, läge och trio-val.
 * Länkarna laddar om sidan, vilket är precis vad man vill vid testning.
 */
const themeLink = (value: HolidayOverride | "auto"): string => {
  const params = new URLSearchParams(window.location.search);
  if (value === "auto") {
    params.delete("theme");
  } else {
    params.set("theme", value);
  }
  const query = params.toString().replace(/%2C/g, ",");
  return `${window.location.pathname}${query ? `?${query}` : ""}`;
};

const Footer: React.FC<FooterProps> = ({ holidayOverride }) => {
  const isAuto = holidayOverride === null;

  return (
    <Stack horizontalAlign="center" tokens={{ childrenGap: "1rem" }} className="footer-container">
      {/* Plattan ger logotypen garanterad kontrast mot dekorerade bakgrunder */}
      <div className="footer-plate">
        <Link href="https://www.rehngruppen.se" target="_blank" className="rehn-link">
          <RehnLogo />
        </Link>

        {/* Testlänkar: förhandsgranska varje högtidstema i både light och dark mode */}
        <nav className="holiday-test-links" aria-label="Förhandsgranska högtidsteman">
        <span className="holiday-test-label">Tema</span>
        <span className="holiday-test-track">
        <a href={themeLink("auto")} className={isAuto ? "active" : ""} title="Låt datumet bestämma tema">
          Auto
        </a>
        {HOLIDAY_KEYS.map(key => (
          <a
            key={key}
            href={themeLink(key)}
            className={holidayOverride === key ? "active" : ""}
            title={`Förhandsgranska ${HOLIDAYS[key].label.toLowerCase()}`}
          >
            {HOLIDAYS[key].label}
          </a>
        ))}
        <a href={themeLink("none")} className={holidayOverride === "none" ? "active" : ""} title="Stäng av högtidstema">
          Av
        </a>
        </span>
        </nav>
      </div>
      <div className="spacer" />
    </Stack>
  );
};

export default Footer;
